import { useFlag } from '@/flags';

/**
 * Accounts that count Source metrics in calendar days at each opening's location.
 * The UI then sends dates rather than browser-offset instants, and "Last N days"
 * covers N calendar days.
 */
export function useLocalDateRanges(): boolean {
  return useFlag('source-location-timezone-ranges');
}
